/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import L from "./Lang"
import BaseCom from "./BaseCom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";

class Redirect extends BaseCom {
    componentDidMount() {
        setTimeout(() => {
            this.props.navigate('/lead/inbound', { replace: true });
        },100);
    }

    render() {
        return null;
    }
}

export default withParamsAndNavigate(Redirect);